import { render, staticRenderFns } from "./dangerGoodsPurchase.vue?vue&type=template&id=3694d2b2&scoped=true"
import script from "./dangerGoodsPurchase.vue?vue&type=script&lang=js"
export * from "./dangerGoodsPurchase.vue?vue&type=script&lang=js"
import style0 from "./dangerGoodsPurchase.vue?vue&type=style&index=0&id=3694d2b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694d2b2",
  null
  
)

export default component.exports